const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChampionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93.9 192.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M79.24,67.48v31a32.29,32.29,0,0,1-64.58,0v-31Z",
    style: {
      fill: "#ccebf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,132.05A33.61,33.61,0,0,1,13.37,98.47v-31H16v31a31,31,0,1,0,62,0v-31h2.59v31A33.62,33.62,0,0,1,47,132.05Z",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.66,
    y: 130.76,
    width: 2.58,
    height: 16.79,
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.82,192.75H12.08V169.5H23.24a4.34,4.34,0,0,0,4.34-4.33V152.72H66.32v12.45a4.34,4.34,0,0,0,4.34,4.33H81.82Zm-67.16-2.58H79.24V172.09H70.66a6.92,6.92,0,0,1-6.92-6.92V155.3H30.16v9.87a6.92,6.92,0,0,1-6.92,6.92H14.66Z",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.66,
    y: 57.15,
    width: 64.57,
    height: 2.58,
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.44,81.72l2.11,6.49a1.77,1.77,0,0,0,1.69,1.22h6.82a.52.52,0,0,1,.3.94l-5.52,4a1.77,1.77,0,0,0-.64,2l2.11,6.49a.52.52,0,0,1-.8.58l-5.52-4a1.74,1.74,0,0,0-2.08,0l-5.52,4a.52.52,0,0,1-.8-.58l2.11-6.49a1.77,1.77,0,0,0-.64-2l-5.52-4a.52.52,0,0,1,.3-.94h6.82a1.77,1.77,0,0,0,1.69-1.22l2.11-6.49A.51.51,0,0,1,47.44,81.72Z",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.44.36l2.11,6.48a1.77,1.77,0,0,0,1.69,1.23h6.82a.51.51,0,0,1,.3.93l-5.52,4a1.78,1.78,0,0,0-.64,2l2.11,6.48a.52.52,0,0,1-.8.58l-5.52-4a1.77,1.77,0,0,0-2.08,0l-5.52,4a.52.52,0,0,1-.8-.58L41.7,15a1.78,1.78,0,0,0-.64-2L35.54,9a.51.51,0,0,1,.3-.93h6.82a1.77,1.77,0,0,0,1.69-1.23L46.46.36A.51.51,0,0,1,47.44.36Z",
    style: {
      fill: "#66c4eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,17.15l2.11,6.48a1.77,1.77,0,0,0,1.68,1.23h6.83a.51.51,0,0,1,.3.93l-5.52,4a1.78,1.78,0,0,0-.64,2l2.1,6.48a.51.51,0,0,1-.79.58l-5.52-4a1.77,1.77,0,0,0-2.08,0l-5.52,4a.52.52,0,0,1-.8-.58l2.11-6.48a1.78,1.78,0,0,0-.64-2l-5.52-4a.51.51,0,0,1,.3-.93h6.82a1.78,1.78,0,0,0,1.69-1.23L80,17.15A.51.51,0,0,1,81,17.15Z",
    style: {
      fill: "#66c4eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.15,17.15l2.11,6.48A1.78,1.78,0,0,0,19,24.86h6.82a.51.51,0,0,1,.3.93l-5.51,4a1.77,1.77,0,0,0-.65,2L22,38.27a.52.52,0,0,1-.8.58l-5.51-4a1.79,1.79,0,0,0-2.09,0l-5.52,4a.51.51,0,0,1-.79-.58l2.1-6.48a1.78,1.78,0,0,0-.64-2l-5.52-4a.51.51,0,0,1,.31-.93h6.82a1.77,1.77,0,0,0,1.68-1.23l2.11-6.48A.51.51,0,0,1,15.15,17.15Z",
    style: {
      fill: "#66c4eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.24,112.68H76.65V110.1h2.59c7.41,0,11.74-6.92,12.06-13.43.29-6-2.76-12.79-12.19-13.7l.25-2.57c11.25,1.09,14.85,9.51,14.52,16.4C93.51,104.5,88.25,112.68,79.24,112.68Z",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25,112.68H14.66C5.65,112.68.39,104.5,0,96.8c-.33-6.89,3.27-15.31,14.52-16.4L14.79,83c-9.43.91-12.48,7.68-12.19,13.7.31,6.51,4.65,13.43,12.06,13.43h2.59Z",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.83,
    y: 169.5,
    width: 34.87,
    height: 2.58,
    style: {
      fill: "#707070"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChampionIcon);
export default __webpack_public_path__ + "static/media/champion-icon.8552a7beacd4068ed773dfb9a4e2a3f5.svg";
export { ForwardRef as ReactComponent };